import { useConfig } from '@app/config';
import { useNftMarketplaceFiltersState } from '@app/state/nftMarketplaceFiltersStore';
import { useAddress } from '@thirdweb-dev/react';
import { Chain } from '@thirdweb-dev/chains';
import { ApplicationConfig } from '@app/config/types';
import { gql, request } from 'graphql-request';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';

async function fetcher(
  apiUrl: string | undefined,
  address: string | undefined,
  listingsIds: string[]
) {
  if (!address || listingsIds.length === 0) {
    return null;
  }

  const res = await request<{ listings: NFTMarketplaceListing[] }>(
    `${apiUrl}`,
    gql`
      query {
        listings (
          orderBy: price,
          where: {
            isNFTAvailable: true,
            id_in: [${listingsIds.join(',')}]
          }
        ) {
          id
          type
          maker
          currency
          price
          tokenId
          reserve
          nftContractAddress
          amount
          start
          end
          isNFTAvailable
          nftPool {
            id
            lpToken {
              symbol
              name
              decimals
              id
            }
          }
          nftMetadata {
            isPremium
          }
        }
      }
    `
  );

  return res.listings;
}

export function useGetListingsForCart(listingsIds: string[]) {
  const config = useConfig();
  const address = useAddress();

  return useQuery<NFTMarketplaceListing[] | null>(
    [
      QueryKeys.GET_NFT_MARKETPLACE_LISTING_FOR_CART,
      address,
      config?.URLS.subgraphUrlNftMarketplace,
      listingsIds
    ],
    () => fetcher(config?.URLS.subgraphUrlNftMarketplace, address, listingsIds)
  );
}
